// extracted by mini-css-extract-plugin
export default {"container":"StatsRow_container__4P9TR","salesInfo":"StatsRow_salesInfo__u8Y3k"};